import { AccountVestingTypeEnum } from 'constants/vesting'

/**
 * Map frontend context type (4|5) to API type (2|3)
 */
export const mapContextTypeToApiType = (type: AccountVestingTypeEnum): 2 | 3 => {
  if (type === AccountVestingTypeEnum.ACCOUNT_VESTING_HMC_V2) return 2
  if (type === AccountVestingTypeEnum.ACCOUNT_VESTING_VENTURE_V2) return 3
  throw new Error(`Invalid account vesting V2 type: ${type}`)
}
